import type { FaireProductEntity } from "../../entity_types/product";

export const p_ksa462v78j: FaireProductEntity = {
  token: "p_ksa462v78j",
  type: "product",
  name: "Not A Hugger Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b4bd7328523ef8cb84ed79e1d6b74577cd7b0e347648055b550ebb1b7723573a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a757f7e941bc62338430d8d0c2ff343bb544a4af23320a8018cd893bddbce94.jpeg",
    "https://cdn.faire.com/fastly/923db172054ba77b552f52da49aa7cec9eeb4351f415ecc08a941b174df782b4.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5b52f33ed7a6a742d0f02e4bf5ea8d47e1b1a39d47e7f7e2905a21e6aa8299ec.jpeg",
    "https://cdn.faire.com/fastly/560552db42520320829f4c7e831d9ca9e8217a43b88368240865b5fff0f748bb.jpeg",
    "https://cdn.faire.com/fastly/b34c64b2002baddfc941dae0e5081ba44ec766e4e00873c2755eeaffe9c2591a.jpeg",
    "https://cdn.faire.com/fastly/36efcbd65f6993757bfd0849a31c4ef8a230c2a9e9a466aca13e11dc9538a88a.jpeg"
  ],
  priceDollars: 6.75,
  description: "This way, you can make the sure the only things hugging you all day are these comfy socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:05.730Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
